import { PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusLogScreenAnalytics } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

interface BillManagerErrorScreenProps {
  messageHeadline: string;
  messageBody: string;
  primaryButton: {
    title: string;
    onPress: () => void;
    analytics?: PressableAnalyticsProps;
  };
  secondaryButton?: {
    title: string;
    onPress: () => void;
  };
}

const BillManagerErrorScreen = ({
  messageHeadline,
  messageBody,
  primaryButton,
  secondaryButton,
}: BillManagerErrorScreenProps) => {
  useViewDidFocusLogScreenAnalytics({
    name: 'Screen Viewed',
    properties: {
      screen_name: 'Bill Manager Error Encountered',
      category: 'bill_manager',
    },
  });

  return (
    <ErrorScreen
      screenType={ErrorScreenType.Error}
      messageHeadline={messageHeadline}
      messageBody={messageBody}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
    />
  );
};

export default BillManagerErrorScreen;
